/* eslint-disable global-require */
import React from 'react';
import { Helmet } from 'react-helmet';
import injectLayout from 'components/MainLayout';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import {
  Header,
  Divider,
  Container,
  Button,
  Grid,
  Image,
  List,
  Form,
  Accordion,
  Loader,
  Transition,
  Message,
  Checkbox,
  Icon,
} from 'semantic-ui-react';
import styles from './index.css';

// eslint-disable-next-line react/prefer-stateless-function
class LynksExport extends React.Component {
  state = {
    name: '',
    phone: '',
    businessName: '',
    skusCount: null,
    sellOnStores: [
      'amazon_us',
      'amazon_eg',
      'amazon_ae',
      'noon_ae',
      'noon_eg',
      'etsy',
      'ebay',
    ],
    loading: false,
    fieldsErrors: [],
    formErrors: [],
    showForm: true,
  };

  toggleSelection = (e, { checked, value }) => {
    if (checked) {
      this.setState({ sellOnStores: [...this.state.sellOnStores, value] });
    } else {
      const newSelection = this.state.sellOnStores.filter((el) => el !== value);
      this.setState({ sellOnStores: newSelection });
    }
  };

  isValidForm = () => {
    const errors = [];
    const fieldsErrors = [];
    const isAr = this.props.intl.locale === 'ar';

    if (!this.state.name.length) {
      errors.push(isAr ? 'من فضلك أدخل الاسم' : 'Name can not be empty');
      fieldsErrors.push('name');
    }
    if (!this.state.phone.length) {
      errors.push(
        isAr ? 'من فضلك أدخل رقم الهاتف' : 'phone Number can not be empty'
      );
      fieldsErrors.push('phone');
    }
    if (this.state.sellOnStores.length === 0) {
      errors.push(
        isAr
          ? 'قم باختيار منصه على الأقل'
          : 'please choose at least one platform'
      );
      fieldsErrors.push('sellOnStores');
    }
    if (this.state.skusCount < 0 || this.state.skusCount == null) {
      errors.push(
        isAr ? 'من فضلك أدخل رقم صحيح' : 'please enter a valid number'
      );
      fieldsErrors.push('skusCount');
    }
    if (fieldsErrors.length) this.setState({ fieldsErrors });
    if (errors.length) this.setState({ formErrors: errors });
    return errors.length === 0;
  };
  register = async () => {
    this.setState({ formErrors: [], fieldsErrors: [] });

    if (!this.isValidForm()) {
      return null;
    }

    this.setState({ loading: true });
    const { name, phone, businessName, skusCount, sellOnStores } = this.state;
    await this.props
      .createLynksExportProspectiveCustomer({
        variables: {
          name,
          phone,
          businessName,
          skusCount,
          sellOnStores,
        },
      })
      .then(() => {
        this.setState({ loading: false });
        this.setState({ showForm: false });
        this.setState({
          name: '',
          phone: '',
          businessName: '',
          skusCount: null,
          sellOnStores: [
            'amazon_us',
            'amazon_eg',
            'amazon_ae',
            'noon_ae',
            'noon_eg',
            'etsy',
            'ebay',
          ],
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.log(err);
      });
  };
  handleDismiss = () => {
    this.setState({ showForm: false });

    setTimeout(() => {
      this.setState({ showForm: true });
    }, 200);
  };
  render() {
    const isAr = this.props.intl.locale === 'ar';
    const options = [
      {
        key: 'amazon_us',
        text: isAr ? 'أمازون أمريكا' : 'Amazon US',
        value: 'amazon_us',
      },
      {
        key: 'amazon_eg',
        text: isAr ? 'أمازون مصر' : 'Amazon Egypt',
        value: 'amazon_eg',
      },
      {
        key: 'amazon_ae',
        text: isAr ? 'أمازون الإمارات' : 'Amazon UAE',
        value: 'amazon_ae',
      },
      {
        key: 'noon_ae',
        text: isAr ? 'نون الإمارات' : 'Noon UAE',
        value: 'noon_ae',
      },
      {
        key: 'noon_eg',
        text: isAr ? 'نون مصر' : 'Noon Egypt',
        value: 'noon_eg',
      },
      {
        key: 'etsy',
        text: isAr ? 'اتسي' : 'Etsy',
        value: 'etsy',
      },
      {
        key: 'ebay',
        text: isAr ? 'ايباي' : 'ebay',
        value: 'ebay',
      },
    ];
    const panels = [
      {
        key: 'question1',
        title: {
          content: isAr ? 'ازاي ابدأ أصدر منتجاتي مع لينكس؟' : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>
                {isAr
                  ? 'لينكس هتعرض وتبيع منتجاتك في الأسواق العالمية داخل أمريكا والإمارات على منصات البيع المختلفة أمازون و نون .'
                  : ''}
              </li>
              <li>
                {isAr
                  ? 'وذلك بعد شحن المنتجات وتخزينها في مستودعات مهيئة بالكامل بحسب نوع المنتج،'
                  : ''}
              </li>
              <li>
                {isAr
                  ? 'لينكس تتولى رحلة الدعاية والتسويق للمنتج على هذه المنصات عن طريق كتابة محتوى دعائي احترافي باللغة الإنجليزية كما تتولي الرد على استفسارات العملاء وخدمات ما بعد البيع.'
                  : ''}
              </li>
              <li>
                {isAr ? 'يمكنك التسجيل من ' : ''}
                <span
                  role="link"
                  tabIndex={0}
                  style={{
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    color: '#4f97fb',
                  }}
                  onClick={() => {
                    this.myRef.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  {isAr ? 'هنا' : ''}
                </span>

                {isAr ? '، سيتم التواصل معك لتنسيق كل الخطوات اللازمة.' : ''}
              </li>
            </ul>
          ),
        },
      },
      {
        key: 'question2',
        title: {
          content: isAr
            ? 'ما هي شروط الانضمام إلى لينكس للبدء في تصدير المنتجات؟'
            : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>
                {isAr
                  ? `الشرط الوحيد هو جودة المنتجات مع وجود صور واضحة لمنتجاتك لعرضها
                على منصات التجارة العالمية.`
                  : ''}
              </li>
            </ul>
          ),
        },
      },
      {
        key: 'question3',
        title: {
          content: isAr
            ? 'هل هناك حد أدنى و حد أقصى لعدد المنتجات قبل البدء؟'
            : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>
                {isAr
                  ? 'لا يوجد حد أدنى أو أقصى لبيع وتصدير المنتجات مع لينكس، يمكنك بيع أي عدد من المنتجات ما دامت بجودة عالية.'
                  : ''}
              </li>
            </ul>
          ),
        },
      },
      {
        key: 'question4',
        title: {
          content: isAr
            ? 'ما هي المسئوليات التي تقع عليَ كصاحب مشروع عند البدء في التصدير مع لينكس؟'
            : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>
                {isAr
                  ? 'لا توجد أي مسئوليات عليك فيما يخص جانب الترتيبات أو الخطوات اللوجستية، فقط صور واضحة لمنتجاتك حتى يتم عرضها وبيعها على المنصات مع لينكس.'
                  : ''}
              </li>
            </ul>
          ),
        },
      },
      {
        key: 'question5',
        title: {
          content: isAr
            ? 'هل أحتاج لوجود رأس مال قبل تصدير منتجاتي مع لينكس؟'
            : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>
                {isAr
                  ? 'لا تحتاج لوجود رأس مال، يمكنك البدء فوراً من دون أي مصاريف افتتاحية باستثناء مصاريف الشحن الدولي.'
                  : ''}
              </li>
            </ul>
          ),
        },
      },
      {
        key: 'question6',
        title: {
          content: isAr ? 'كيف يتم حساب الشحن الدولي للمنتجات؟' : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>
                {isAr
                  ? 'لينكس تقوم بالشحن الدولي لمنتجاتك بمصاريف تبلغ 8 دولار لكل كيلو جرام.'
                  : ''}
              </li>
            </ul>
          ),
        },
      },
      {
        key: 'question7',
        title: {
          content: isAr ? 'ما هي مصاريف الخدمة المطلوبة؟' : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>
                {isAr
                  ? 'يتم حساب تكلفة الخدمة كنسبة مئوية تبلغ 10% من إجمالي البيع، وبذلك لن تكن هناك أي مصاريف أخرى قبل البيع باستثناء مصاريف الشحن.'
                  : ''}
              </li>
            </ul>
          ),
        },
      },
      {
        key: 'question8',
        title: {
          content: isAr ? 'كيف تتم إدارة المرتجعات؟' : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>
                {isAr
                  ? 'لينكس تقوم بمتابعة مخزون المنتج وإدارة المرتجع وتتحمل عنك كل الخطوات اللوجستية لهذه المهمة.'
                  : ''}
              </li>
            </ul>
          ),
        },
      },
      {
        key: 'question9',
        title: {
          content: isAr
            ? 'ما هي المنصات المتاحة لعرض منتجاتي داخل أمريكا ، مصر ، والإمارات؟'
            : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>{isAr ? 'أمازون أمريكا' : 'Amazon US'}</li>
              <li>{isAr ? 'أمازون مصر' : 'Amazon Egypt'}</li>
              <li>{isAr ? 'أمازون الإمارات' : 'Amazon UAE'}</li>
              <li>{isAr ? 'نون الإمارات' : 'Noon UAE'}</li>
              <li>{isAr ? 'نون مصر' : 'Noon Egypt'}</li>
              <li>{isAr ? 'اتسي' : 'Etsy'}</li>
              <li>{isAr ? 'ايباي' : 'ebay'}</li>
            </ul>
          ),
        },
      },
      {
        key: 'question10',
        title: {
          content: isAr ? 'كيف يتم تسليم الأرباح؟' : '',
        },
        content: {
          content: (
            <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
              <li>
                {isAr
                  ? 'يتم تسليم أرباح الشهر في أول يوم أحد بأول اسبوع من الشهر التالي له، مخصوماً منها عمولة لينكس - حوالي 10% - بالإضافة لعمولة منصة العرض ( أمازون - نون - اتسي - ايباي ). يتم احتساب الربح بالجنيه المصري بسعر الدولار الموجود في البنك.'
                  : ''}
              </li>
            </ul>
          ),
        },
      },
      {
        key: 'question11',
        title: {
          content: isAr ? 'كم تبلغ عمولة منصات العرض؟' : '',
        },
        content: {
          content: (
            <div>
              <p>
                {isAr
                  ? `تختلف النسبة من منصة لأخرى بحسب الموقع نفسه أو بحسب نوع المنتجات
            التي تعرضها`
                  : ''}
              </p>
              <ul style={{ lineHeight: 1.7, fontSize: '1.2rem' }}>
                <li>{isAr ? 'أمازون : من 8 إلى 15 %' : ''}</li>
                <li>{isAr ? 'ايباي : من 2 إلى 12 %' : ''}</li>
                <li>{isAr ? 'اتسي : حوالي 6.5%' : ''}</li>
                <li>{isAr ? 'نون : من 5 إلى 27%' : ''}</li>
              </ul>
            </div>
          ),
        },
      },
      {
        key: 'question12',
        title: {
          content: isAr ? 'كيف يمكنني التواصل مع لينكس لأي استفسار؟' : '',
        },
        content: {
          content: (
            <p>
              {isAr ? 'قم بمراسلتنا من خلال الإيميل: ' : ''}
              <a href="mailto:support@lynks.com">support@lynks.com</a>
            </p>
          ),
        },
      },
    ];
    return (
      <div>
        <Helmet>
          <title>
            {isAr
              ? 'صدر منتجاتك لأسواق عالمية و كبر مشروعك مع لينكس'
              : 'Export your products to global markets and widen your project with Lynks'}
          </title>
          <meta
            name="description"
            content={
              isAr
                ? 'منتجاتك هتتعرض وتتباع في كل المنصات العالمية المختلفة داخل أمريكا والإمارات بأحسن شكل ومن غير أي مجهود منك'
                : 'Your products will be displayed and sold on all the different international platforms inside America and the UAE in the best way and without any effort on your part'
            }
          />
        </Helmet>

        <div>
          {/* above the fold */}
          <div
            style={{
              backgroundColor: '#fff',
              borderBottom: '1px solid #dadada',
            }}
            ref={(c) => {
              this.myRef = c;
            }}
          >
            <Container style={{ padding: '5em 0' }}>
              <Header
                as="h1"
                size="huge"
                style={{ textAlign: 'center' }}
                id={styles.mainHeader}
              >
                {isAr
                  ? 'صدر منتجاتك لأسواق عالمية و كبر مشروعك مع لينكس'
                  : 'Export your products to global markets and widen your project with Lynks'}
              </Header>

              <Divider section hidden />
              <Grid>
                <Grid.Row
                  reversed={isAr ? 'computer' : false}
                  style={{ height: '100%' }}
                >
                  <Grid.Column
                    mobile={16}
                    tablet={7}
                    computer={7}
                    textAlign="center"
                    verticalAlign="middle"
                    style={{ height: '100%' }}
                  >
                    {this.state.showForm ? (
                      <div
                        style={{
                          background: '#f1eff0',
                          padding: '2rem 1rem',
                          borderRadius: '8px',
                        }}
                      >
                        <Header
                          as="h1"
                          size="huge"
                          style={{
                            textAlign: 'center',
                            padding: '2rem 0 1rem 0',
                          }}
                        >
                          {isAr ? 'ابدأ معنا' : 'Start with us'}
                        </Header>

                        <Transition
                          visible={this.state.formErrors.length > 0}
                          animation="scale"
                        >
                          <Message
                            error
                            list={this.state.formErrors}
                            style={{
                              textAlign:
                                this.props.intl.locale === 'ar'
                                  ? 'right'
                                  : 'left',
                              direction:
                                this.props.intl.locale === 'ar'
                                  ? 'right'
                                  : 'left',
                            }}
                          />
                        </Transition>
                        <Form size="big" onSubmit={this.handleSubmit}>
                          <Form.Field
                            disabled={this.state.loading}
                            ref={(e) => {
                              this.fullNameRef = e;
                            }}
                            error={this.state.fieldsErrors.indexOf('name') > -1}
                          >
                            <input
                              className={styles.fromField}
                              type="text"
                              placeholder={isAr ? 'الاسم' : 'Full Name'}
                              value={this.state.name}
                              onChange={(e) => {
                                this.setState({ name: e.target.value });
                              }}
                              onFocus={() => {
                                const fullNameIndex =
                                  this.state.fieldsErrors.indexOf('name');
                                this.state.fieldsErrors.splice(
                                  fullNameIndex,
                                  1
                                );
                                this.state.formErrors.splice(fullNameIndex, 1);
                              }}
                            />
                          </Form.Field>

                          <Form.Field
                            disabled={this.state.loading}
                            error={
                              this.state.fieldsErrors.indexOf('phone') > -1
                            }
                          >
                            <input
                              className={styles.fromField}
                              type="tel"
                              placeholder={isAr ? 'رقم الهاتف' : 'Phone Number'}
                              value={this.state.phone}
                              onChange={(e) => {
                                this.setState({ phone: e.target.value });
                              }}
                              onFocus={() => {
                                const phone =
                                  this.state.fieldsErrors.indexOf('phone');
                                this.state.fieldsErrors.splice(phone, 1);
                                this.state.formErrors.splice(phone, 1);
                              }}
                            />
                          </Form.Field>
                          <Form.Field disabled={this.state.loading}>
                            <input
                              className={styles.fromField}
                              type="text"
                              placeholder={
                                isAr
                                  ? 'اسم البيزنس (اختياري)'
                                  : 'Business Name (optional)'
                              }
                              value={this.state.businessName}
                              onChange={(e) => {
                                this.setState({ businessName: e.target.value });
                              }}
                            />
                          </Form.Field>

                          <Form.Field
                            disabled={this.state.loading}
                            error={
                              this.state.fieldsErrors.indexOf('skusCount') > -1
                            }
                          >
                            <input
                              className={styles.fromField}
                              type="number"
                              placeholder={
                                isAr
                                  ? 'عدد المنتجات الخاصة بمشروعك'
                                  : 'Number of products'
                              }
                              value={this.state.skusCount}
                              onChange={(e) => {
                                this.setState({
                                  skusCount: +e.target.value,
                                });
                              }}
                              onFocus={() => {
                                const skusCount =
                                  this.state.fieldsErrors.indexOf('skusCount');
                                this.state.fieldsErrors.splice(skusCount, 1);
                                this.state.formErrors.splice(skusCount, 1);
                              }}
                            />
                          </Form.Field>

                          <label
                            htmlFor="sellOnStores"
                            style={{
                              width: '100%',
                              display: 'block',
                              textAlign: 'start',
                              marginBottom: '1em',
                              fontWeight: 'bold',
                            }}
                          >
                            {isAr
                              ? 'المنصات التي ترغب بالتسويق من خلالها'
                              : 'The platforms you want to market through'}
                          </label>
                          <Form.Group
                            style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(2,minmax(0,1fr)',
                            }}
                          >
                            {options.map(({ text, key }) => (
                              <Form.Field
                                style={{
                                  width: 'fit-content',
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexDirection: 'row-reverse',
                                  gap: '10px',
                                }}
                                disabled={this.state.loading}
                                error={
                                  this.state.fieldsErrors.indexOf(
                                    'sellOnStores'
                                  ) > -1
                                }
                                onClick={() => {
                                  const sellOnStores =
                                    this.state.fieldsErrors.indexOf(
                                      'sellOnStores'
                                    );
                                  this.state.fieldsErrors.splice(
                                    sellOnStores,
                                    1
                                  );
                                  this.state.formErrors.splice(sellOnStores, 1);
                                }}
                              >
                                <label
                                  htmlFor={key}
                                  style={{
                                    fontWeight: 'normal',
                                  }}
                                >
                                  {text}
                                </label>
                                <Checkbox
                                  value={key}
                                  defaultChecked
                                  onChange={this.toggleSelection}
                                />
                              </Form.Field>
                            ))}
                          </Form.Group>

                          <Button
                            type="submit"
                            style={{
                              borderRadius: '1rem',
                              backgroundColor: '#ff5400',
                              color: '#fff',
                              fontSize: '2rem',
                              width: '100%',
                              margin: '10px 0',
                            }}
                            onClick={this.register}
                            disabled={this.state.loading}
                          >
                            {isAr ? 'تسجيل' : 'Register'}{' '}
                            {this.state.loading && (
                              <Loader active inverted inline />
                            )}
                          </Button>
                        </Form>
                      </div>
                    ) : (
                      <Message
                        positive
                        onDismiss={this.handleDismiss}
                        style={{
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '20px',
                          transition: 'all 0.2s ease-in-out',
                        }}
                      >
                        <Message.Header>
                          <Icon name="check circle" size="huge" />
                          <br />
                          <h1>
                            {' '}
                            {isAr
                              ? 'تم التسجيل بنجاح'
                              : 'Registered Successfully'}
                          </h1>
                        </Message.Header>
                        <p style={{ fontSize: '1.7rem', padding: '0.5rem' }}>
                          {isAr
                            ? 'سوف نتواصل معك في خلال 48 ساعة'
                            : 'We will contact you in 48hrs'}
                          <br />
                          {isAr
                            ? 'شكرا لاختيارك لينكس'
                            : 'Thank you for chosing Lynks'}
                        </p>
                      </Message>
                    )}
                  </Grid.Column>

                  <Grid.Column
                    mobile={16}
                    tablet={9}
                    computer={9}
                    verticalAlign="middle"
                    style={{ marginTop: '1rem' }}
                  >
                    <Image
                      src={require('./assets/Sec-1/above_the_fold.webp')}
                      centered
                      size="huge"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider hidden section />
              <Header
                style={{
                  textAlign: 'center',
                  fontWeight: 'normal',
                  fontSize: window.innerWidth > 900 ? '1.7rem' : '1.5rem',
                  lineHeight: '2.5rem',
                }}
              >
                {isAr
                  ? 'منتجاتك هتتعرض وتتباع في كل المنصات العالمية المختلفة داخل أمريكا والإمارات'
                  : 'Your products will be displayed and sold on all the different international platforms inside America and the UAE'}
                <br />
                {isAr
                  ? 'بأحسن شكل ومن غير أي مجهود منك'
                  : 'in the best way and without any effort on your part'}
              </Header>
              <Divider section hidden />
              <Grid columns="equal" textAlign="center">
                <Grid.Column mobile={5} tablet={5} computer={3}>
                  <Image
                    size="small"
                    centered
                    src={require('./assets/Sec-1/ebay_logo.webp')}
                  />
                </Grid.Column>
                <Grid.Column mobile={5} tablet={5} computer={3}>
                  <Image
                    size="small"
                    centered
                    src={require('./assets/Sec-1/etsy_logo.webp')}
                  />
                </Grid.Column>
                <Grid.Column mobile={5} tablet={5} computer={3}>
                  <Image
                    size="small"
                    centered
                    src={require('./assets/Sec-1/amazon_logo.webp')}
                  />
                  <Divider hidden />
                </Grid.Column>
                <Grid.Column mobile={5} tablet={5} computer={3}>
                  <Image
                    size="small"
                    centered
                    src={require('./assets/Sec-1/noon_logo.webp')}
                  />
                </Grid.Column>
              </Grid>
            </Container>
          </div>

          {/* section2 - grid */}
          <div
            style={{
              borderTop: '1px solid #dadada',
            }}
            className={styles.exportSection}
          >
            <Container id="stores" style={{ padding: '5em 0' }}>
              <Header
                as="h1"
                textAlign="center"
                style={{ lineHeight: '2.5rem' }}
              >
                {isAr
                  ? 'ازاي هتقدر تكبر مشروعك مع لينكس'
                  : 'How to grow your project with Lynks'}
                <br />
                {isAr ? 'بسهولة؟' : 'easily?'}
              </Header>

              <Divider section hidden />

              <Grid columns="equal" textAlign="center">
                <Grid.Row reversed={isAr ? 'computer' : false}>
                  <Grid.Column mobile={16} tablet={8} computer={5}>
                    <Image
                      size="tiny"
                      centered
                      src={require('./assets/Sec-2/icon_1.webp')}
                    />
                    <Divider hidden />
                    <p
                      style={{
                        color: '#7a7a7a',
                        fontSize: '1.25rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {isAr
                        ? 'هتصدر منتجاتك للخارج وتبيع في أسواق عالمية بهامش ربح عالي'
                        : 'You will export your products abroad and sell them in global markets with a high profit margin'}
                    </p>
                    <Divider hidden />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={8} computer={5}>
                    <Image
                      size="tiny"
                      centered
                      src={require('./assets/Sec-2/icon_2.webp')}
                    />
                    <Divider hidden />
                    <p
                      style={{
                        color: '#7a7a7a',
                        fontSize: '1.25rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {isAr
                        ? 'لينكس هتتولى كل الترتيبات والخطوات اللوجستية من شحن دولي و تخرين آمن لمنتجاتك'
                        : 'Lynks will take care of all the logistical arrangements and steps of international shipping and safe storage of your products'}
                    </p>
                    <Divider hidden />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={8} computer={5}>
                    <Image
                      size="tiny"
                      centered
                      src={require('./assets/Sec-2/icon_3.webp')}
                    />
                    <Divider hidden />

                    <p
                      style={{
                        color: '#7a7a7a',
                        fontSize: '1.25rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {isAr
                        ? 'دعاية احترافية لمنتجاتك على منصات أمازون و نون في أمريكا والإمارات'
                        : 'Professional advertising for your products on Amazon and Noon platforms in America and the UAE'}
                    </p>
                    <Divider hidden />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column mobile={16} tablet={8} computer={5}>
                    <Image
                      size="tiny"
                      centered
                      src={require('./assets/Sec-2/icon_4.webp')}
                    />
                    <Divider hidden />

                    <p
                      style={{
                        color: '#7a7a7a',
                        fontSize: '1.25rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {isAr
                        ? 'محتوى دعائي وتوصيف دقيق لمنتجك باللغة الإنجليزية'
                        : 'Sponsored content and accurate description of your product in English'}
                    </p>
                    <Divider hidden />
                  </Grid.Column>

                  <Grid.Column mobile={16} tablet={8} computer={5}>
                    <Image
                      size="tiny"
                      centered
                      src={require('./assets/Sec-2/icon_5.webp')}
                    />
                    <Divider hidden />

                    <p
                      style={{
                        color: '#7a7a7a',
                        fontSize: '1.25rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {isAr
                        ? 'خدمة عملاء احترافية للرد على الاستفسارات'
                        : 'Professional customer service to answer inquiries'}
                    </p>
                    <Divider hidden />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={8} computer={5}>
                    <Image
                      size="tiny"
                      centered
                      src={require('./assets/Sec-2/icon_6.webp')}
                    />
                    <Divider hidden />
                    <p
                      style={{
                        color: '#7a7a7a',
                        fontSize: '1.25rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {isAr
                        ? 'خدمة ما بعد البيع وإدارة'
                        : 'After-sales service'}
                      <br />
                      {isAr ? 'المرتجعات' : 'and returns management'}
                    </p>
                    <Divider hidden />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </div>
          {/* section3 - list */}
          <div className={styles.section3}>
            <Container style={{ padding: '5em 0' }}>
              <Header
                as="h1"
                size="huge"
                style={{ textAlign: 'center' }}
                id={styles.mainHeader}
              >
                {isAr
                  ? 'لينكس هتسهلها عليك…'
                  : 'Lynks will make it possible...'}
              </Header>

              <Divider section hidden />
              <Grid>
                <Grid.Row reversed={isAr ? 'computer' : false}>
                  <Grid.Column
                    mobile={16}
                    tablet={7}
                    computer={7}
                    textAlign="center"
                    verticalAlign="middle"
                  >
                    <Image
                      src={require('./assets/Sec-3/section_3_object.webp')}
                      centered
                      size="huge"
                    />
                  </Grid.Column>

                  <Grid.Column
                    mobile={16}
                    tablet={9}
                    computer={9}
                    verticalAlign="middle"
                  >
                    <List bulleted dir={isAr ? 'rtl' : 'ltr'} size="huge">
                      <List.Item className={styles.listItem}>
                        <List.Content>
                          <List.Header
                            style={{
                              fontSize: '2rem',
                              color: '#4F97FB',
                              wordSpacing: '0.2em',
                              lineHeight: '1.2em',
                            }}
                          >
                            {isAr
                              ? 'التسجيل عليك والشحن والمتابعة علينا'
                              : 'Register, charge and follow up on us'}
                          </List.Header>

                          <List.Description
                            style={{
                              margin: '1em 0',
                              color: '#7a7a7a',
                              lineHeight: '2.5rem',
                            }}
                          >
                            {isAr
                              ? 'لينكس هتكون مسئولة عن استلام المنتجات وشحنها للخارج لتخزينها قبل مرحلة البيع.'
                              : 'Lynks will be responsible for receiving the products and shipping them abroad for pre-sale storage'}
                          </List.Description>
                        </List.Content>
                      </List.Item>

                      <List.Item className={styles.listItem}>
                        <List.Content>
                          <List.Header
                            style={{
                              fontSize: '2rem',
                              color: '#4F97FB',
                              wordSpacing: '0.2em',
                              lineHeight: '1.2em',
                            }}
                          >
                            {isAr
                              ? 'تسويق  وعرض احترافي لمنتجاتك'
                              : 'Marketing and professional presentation of your products'}
                          </List.Header>
                          <List.Description
                            style={{
                              margin: '1em 0',
                              color: '#7a7a7a',
                              lineHeight: '2.5rem',
                            }}
                          >
                            {isAr
                              ? 'هنقوم بعرض منتجاتك في المنصات العالمية المختلفة مثل امازون و نون في أمريكا والإمارات بعد كتابة محتوى احترافي باللغة الإنجليزية لشرح المنتج.'
                              : 'We will display your products on various international platforms such as Amazon and Noon in America and the UAE after writing professional content in English to explain the product'}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                      <List.Item className={styles.listItem}>
                        <List.Content>
                          <List.Header
                            style={{
                              fontSize: '2rem',
                              color: '#4F97FB',
                              wordSpacing: '0.2em',
                              lineHeight: '1.2em',
                            }}
                          >
                            {isAr
                              ? 'فريق خدمة عملاء جاهز لخدمة منتجك'
                              : 'A customer service team ready to serve your product'}
                          </List.Header>
                          <List.Description
                            style={{
                              margin: '1em 0',
                              color: '#7a7a7a',
                              lineHeight: '2.5rem',
                            }}
                          >
                            {isAr
                              ? 'خدمة عملاء مخصصة للرد على الاستفسارات ومتابعة آراء العملاء.'
                              : 'Dedicated customer service to answer inquiries and follow up on customer opinions'}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                      <List.Item className={styles.listItem}>
                        <List.Content>
                          <List.Header
                            style={{
                              fontSize: '2rem',
                              color: '#4F97FB',
                              wordSpacing: '0.2em',
                              lineHeight: '1.2em',
                            }}
                          >
                            {isAr ? 'خدمة ما بعد البيع' : 'After sales service'}
                          </List.Header>
                          <List.Description
                            style={{
                              margin: '1em 0',
                              color: '#7a7a7a',
                              lineHeight: '2.5rem',
                            }}
                          >
                            {isAr
                              ? 'إدارة المرتجعات في حال وجودها مع متابعة المتبقي من المنتج.'
                              : 'Manage returns, if any, and follow up on the remainder of the product'}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                      <List.Item className={styles.listItem}>
                        <List.Content>
                          <List.Header
                            style={{
                              fontSize: '2rem',
                              color: '#4F97FB',
                              wordSpacing: '0.2em',
                              lineHeight: '1.2em',
                            }}
                          >
                            {isAr
                              ? 'وأخيراً … استلام أرباحك'
                              : 'And finally... receive your winnings'}
                          </List.Header>
                          <List.Description
                            style={{
                              margin: '1em 0',
                              color: '#7a7a7a',
                              lineHeight: '2.5rem',
                            }}
                          >
                            {isAr
                              ? 'أرباحك بعد البيع هتوصلك بسهولة ومن غير أي تأخير.'
                              : 'Your profits after the sale will reach you easily and without any delay'}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                    </List>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </div>
          {/* section4 - contact button */}
          <div className={styles.section4}>
            <Container style={{ padding: '5em 0' }}>
              <Header as="h1" size="huge" style={{ textAlign: 'center' }}>
                {isAr
                  ? 'تواصل معنا لمعرفة المزيد من التفاصيل'
                  : 'Contact with us for more details'}
              </Header>

              <Divider section hidden />
              <Button
                size="massive"
                style={{
                  borderRadius: '1rem',
                  padding: '2rem 2.5rem',
                  backgroundColor: '#ff5400',
                  color: '#fff',
                  fontSize: '2rem',
                }}
                as="a"
                className={styles.CTAButton}
                onClick={() => {
                  this.myRef.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                {isAr ? 'سجل الآن' : 'Register Now'}
              </Button>
            </Container>
          </div>
          <div>
            {isAr && (
              <Container style={{ padding: '5em 0' }}>
                <Header as="h1" size="huge" style={{ textAlign: 'center' }}>
                  {isAr ? 'الأسئلة الشائعة' : 'FAQs'}
                </Header>
                <Accordion styled fluid panels={panels} id={styles.accordion} />
              </Container>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const CREATE_LYNKS_EXPORT = gql`
  mutation createLynksExportProspectiveCustomer(
    $name: String!
    $phone: String!
    $businessName: String!
    $skusCount: Int!
    $sellOnStores: [String!]!
  ) {
    createLynksExportProspectiveCustomer(
      name: $name
      phone: $phone
      businessName: $businessName
      skusCount: $skusCount
      sellOnStores: $sellOnStores
    )
  }
`;
export default compose(
  injectIntl,
  withRouter,
  injectLayout,
  graphql(CREATE_LYNKS_EXPORT, {
    name: 'createLynksExportProspectiveCustomer',
  })
)(LynksExport);



// WEBPACK FOOTER //
// ./app/containers/StaticPage/LynksExport/index.js